module.exports = __webpack_public_path__ + "fonts/prompt-v4-thai_latin-100.c6b10878.woff2";